export default "__VITE_ASSET__CnlA4s2Z__"